import React, { Fragment } from 'react';

import './ImageBox.css';
import Message from "../Message/Message";
import Uploade from "../Upload/Upload";
  
const ImageBox = (props) => (
  <Fragment>
  {props.mode === "complex" &&
    <div className="uk-flex uk-flex-bottom">
      <Uploade
        id={props.id}
        onChange={props.onChange}
        onBlur={props.onBlur}
        imageUrl={props.imageUrl}
      />
      <Message
        title="شرایط فایل"
        messages={[
          "۱- صاف و به همراه نوشته‌های خوانا و واضح",
          "۲- حجم زیر ۲۰ کیلوبایت",
        ]}
        mode="primary"
      />
      <div className="c-RD-profile__add-doc-error uk-hidden">
        <div className="c-RD-profile__checking">
          <Message
            messages={["سایز عکس بیش از ۲ مگابایت می‌باشد"]}
            mode="alert"
          />
        </div>
      </div>
    </div>
  }
  {props.mode === "simple" &&
    <Fragment>
      <label className="uk-form-label">{props.label}
          { props.required === "required" && <span className="uk-form-label__required"></span>}
      </label>
      <div className="field-wrapper">
        <div id="newBrandLogoUpload"
          className={[
            "c-content-modal__uploads-label",
            `${props.imageActive ? "" : "empty"}`,
            `${props.loading ? "loading" : ""}`,
          ].join(" ")}
        >
              <span uk-form-custom="" className="uk-form-custom">
                <input
                  type="file"                  
                  accept="image/jpg,image/png,image/jpeg"
                  className="hidden"
                  id={props.id}
                  onChange={(e) =>
                    props.onChange(
                      props.id,
                      e.target.value,
                      e.target.files
                    )
                  }
                  onBlur={props.onBlur}
                />
              </span>
              <label for={props.id} className="c-content-modal__uploads-preview">
                  <img src={props.imageUrl} id="newBrandLogoUploadPreview" className="c-content-modal__uploads-img" alt=""/> 
                  <span className="c-content-upload__img-loader js-img-loader">
                      <span className="progress__wrapper">
                          <span className="progress"></span>
                      </span>
                  </span>
              </label> 
              <span className="c-content-modal__list c-content-modal__uploads-tooltips">
                  <span className="c-content-modal__uploads-text">
                      لوگو برند را در ابعاد ۶۰۰×۶۰۰ پیکسل و با فرمت PNG یا JPEG و پس‌زمینه‌ی سفید بارگذاری کنید.
                  </span>
              </span>
          </div>
          <input type="hidden" name="brand[logo_id]" className="force-validation" id="logoImageTempId" value=""/>
          <div className="c-content-modal__errors-full" id="newBrandLogoUploadErrors">
              <div>نسبت تصویر لوگو باید یک در یک باشد یا حالت مربعی داشته باشد . لوگو دارای فرمت مناسب نیست  .ارتفاع لوگو نباید بیشتر از 600 پیکسل باشد</div>
          </div>
      </div>
    </Fragment>
  }
  </Fragment>
);

export default ImageBox;
